import { render, staticRenderFns } from "./SubjectCreate.vue?vue&type=template&id=70ed35c8"
import script from "../../controllers/subject/subject-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/subject/subject-create.js?vue&type=script&lang=js&external"
import style0 from "./SubjectCreate.vue?vue&type=style&index=0&id=70ed35c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports